import { useLocaleSwitchApp } from '@base/hooks/i18n';

import { injectedComponent } from '@base/core';

export default injectedComponent(
  {
    name: 'LoggedLandingGuard',
    services: ['access'],
  },
  function LoggedLandingGuard({ children, services: { access } }) {
    const switchApp = useLocaleSwitchApp();
    if (!access.hasAnyAccess()) {
      return children;
    } else {
      switchApp('my');
    }

    return null;
  }
);
